import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, TextField, Button, Box, Typography } from '@mui/material';

const AssignAsanaLibrary = ({ open, onClose, courseList, selectedCourses, setSelectedCourses, onAssign }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pb: 0 }}>Assign Asana to Course</DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1, mt: 1 }}>
          Select the course where you want to assign the selected asanas:
        </Typography>

        <Autocomplete
          options={courseList.filter((option) => option?.courseName)}
          getOptionLabel={(option) => option?.courseName || ''}
          value={selectedCourses}
          onChange={(event, newValue) => setSelectedCourses(newValue)}
          renderInput={(params) => <TextField {...params} label="Course" placeholder="Type to search..." variant="outlined" fullWidth />}
          isOptionEqualToValue={(option, value) => option.courseId === value.courseId}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="secondary">
          Cancel
        </Button>
        <Button onClick={onAssign} variant="contained" disabled={!selectedCourses}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignAsanaLibrary;
